import { randomFirestoreID } from "helpers/Utils"

const ensureRowsHaveIds = rows =>
  (rows || []).map(row => ({
    ...row,
    ID: row.ID || `ROW_${randomFirestoreID()}`,
  }))

const normalizeWidgetData = widgetData => {
  const data = widgetData?.data || {}

  return {
    ...widgetData,
    data: {
      ...data,
      1: {
        ...(data["1"] || {}),
        data: ensureRowsHaveIds(data["1"]?.data || []),
      },
      2: {
        ...(data["2"] || {}),
        data: ensureRowsHaveIds(data["2"]?.data || []),
      },
    },
    dataList: {
      ...(widgetData?.dataList || {}),
      links: ensureRowsHaveIds(widgetData?.dataList?.links || []),
      widget: {
        ...(widgetData?.dataList?.widget || {}),
        row_1: { ...(widgetData?.dataList?.widget?.row_1 || {}) },
        row_2: { ...(widgetData?.dataList?.widget?.row_2 || {}) },
      },
    },
  }
}

const stripRowIds = rows => (rows || []).map(({ ID, ...rest }) => rest)

const normalizeNumericValues = rows =>
  (rows || []).map(row => {
    const parsed = Number(row?.value)

    return {
      ...row,
      value: Number.isFinite(parsed) ? parsed : 0,
    }
  })

const prepareWidgetDataForSave = widgetData => ({
  ...widgetData,
  data: {
    ...(widgetData?.data || {}),
    1: {
      ...(widgetData?.data?.["1"] || {}),
      data: normalizeNumericValues(stripRowIds(widgetData?.data?.["1"]?.data)),
    },
    2: {
      ...(widgetData?.data?.["2"] || {}),
      data: normalizeNumericValues(stripRowIds(widgetData?.data?.["2"]?.data)),
    },
  },
  dataList: {
    ...(widgetData?.dataList || {}),
    links: stripRowIds(widgetData?.dataList?.links),
  },
})

export { normalizeWidgetData, prepareWidgetDataForSave }
